/**
 * „Zusagen mit neuer Fassung“ (Antoine, 04.11.2026, sql/770).
 *
 * Hat der Betreiber ein gesendetes Angebot so geändert, dass sich die Geldgrundlage ändert (z. B. auf à la carte umgestellt),
 * sperrt der Marker alle Annahmewege für den GAST. Der Betreiber kann trotzdem zusagen: ein Klick, MAESTRO hält die AKTUELLE
 * Fassung fest (wie ein Versand, aber OHNE Mail an den Gast) und sagt danach zu. Hier stehen nur die Texte; der Server prüft,
 * rechnet und entscheidet (Beträge nie vom Client).
 *
 * Deutsche Anführungszeichen: öffnend „ (U+201E), schließend “ (U+201C), nie das gerade ".
 */
export const ZUSAGE_NEUE_FASSUNG_HINWEIS = "Das Angebot wurde nach dem Versand geändert. Beim Zusagen hält MAESTRO die aktuelle Fassung fest (ohne Mail an den Gast).";
export const ZUSAGE_NEUE_FASSUNG_TITEL = "Zusagen mit neuer Fassung?";
export const ZUSAGE_NEUE_FASSUNG_KNOPF = "Zusagen mit neuer Fassung";
